import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import { AppBar } from './style';
import AppBarLayout from './appbar';
//import SideNavBar from './sidenavbar';
import Footer from './footer';
import SideNavBar from './sidenavbar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { DrawerHeader, Drawer } from './sidenavbar/style';

const MainLayout = (props) => {
  //const classes = useStyles();
  const { children } = props;
  const [handleOpen, setHandleOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      <AppBarLayout handle={[handleOpen, setHandleOpen]} />
      <SideNavBar open={handleOpen} setOpen={setHandleOpen} />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
};
/*
 <SideNavBar open={handleOpen} setOpen={setHandleOpen}/>    
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
    <DrawerHeader />
    {children}
    </Box>
*/

// const MainLayout = (props) => {
//   const classes = useStyles();
//   const { children } = props;
//   const [handleOpen, setHandleOpen] = React.useState(false);

//   return (
//     <div className={classes.root}>
//       <CssBaseline />
//       <AppBarLayout handle={[handleOpen, setHandleOpen]} />
//       <SideNavBar handle={[handleOpen, setHandleOpen]} />
//       <main
//         className={clsx(classes.content, {
//           [classes.contentShift]: handleOpen,
//         })}
//       >
//         {children}
//         <Footer />
//       </main>
//     </div>
//   );
// };
MainLayout.prototype = {
  children: PropTypes.node.isRequired,
};
export default MainLayout;
